import { POIPrivateInner } from './poi-private-inner';

export default POIPrivateInner;
